import omit from 'lodash/omit';

export default (props: object): object =>
    omit(props, [
        'addLabel',
        'allowEmpty',
        'basePath',
        'cellClassName',
        'cellStyle',
        'className',
        'emptyText',
        'formClassName',
        'headerClassName',
        'headerStyle',
        'label',
        'linkType',
        'link',
        'locale',
        'record',
        'resource',
        'sortable',
        'sortBy',
        'source',
        'textAlign',
        'translateChoice',
    ]);
